import Link from 'next/link';
import styled from 'styled-components';

const BreadCrumbsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 2px;
`;

const Crumb = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0;
  a {
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1.25rem;
    color: ${(props) => props.theme.secondaryText};
    cursor: pointer;
    transition: 0.225s all;
  }
  &:hover a {
    color: ${(props) => props.theme.primary};
  }
`;

const CrumbIcon = styled.span`
  width: 16px;
  height: 16px;
  font-size: 1rem;
  color: ${(props) => props.theme.secondaryText};
`;

export default function BreadCrumbs(props) {
  const breadcrumbs = props.breadcrumbs;
  return (
    <BreadCrumbsWrapper>
      {breadcrumbs &&
        breadcrumbs.map((crumb, i, { length }) => (
          <Crumb key={crumb.name}>
            <Link href={crumb.path}>
              <a>{crumb.name}</a>
            </Link>
            {length - 1 !== i ? (
              <CrumbIcon className="material-icons">chevron_right</CrumbIcon>
            ) : null}
          </Crumb>
        ))}
    </BreadCrumbsWrapper>
  );
}
